<template>
  <v-tooltip
    location="bottom"
    color="primary"
    attach="#approot"
  >
    <template #activator="{ props : activatorProps }">
      <div
        :class="contentClass"
        v-bind="activatorProps"
      >
        <slot name="content" />
      </div>
    </template>
    <div class="file-tooltip-content">
      <span>{{ $t("Filename") }}: </span>
      {{ props.file.fileName }}
      <br>
      <span v-if="props.file.comment">{{ $t("Comment") }}: </span>
      {{ props.file.comment }}
    </div>
  </v-tooltip>
</template>

<script setup lang="ts">


defineOptions({ name: "FileTooltip" });

const props = defineProps({
  file: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  contentClass: {
    type: String,
    default: () => "",
  },
});
</script>

<style lang="scss">
.v-overlay__content:has(.file-tooltip-content) {
  background-color: rgb(var(--v-theme-primary));
}

.file-tooltip-content {
  span {
    font-weight: 500;
  }
}
</style>
